import { PersonalizeSearchPricingHistogramDataProvider } from 'site-modules/shared/components/inventory/usurp-histogram/personalize-search-pricing-histogram-data-provider';
import { PersonalizedSaveSearchDataProvider } from 'site-modules/shared/components/inventory/srp-save-search/personalized-save-search-data-provider';

export const personalizeSearchDependencyContextValue = {
  filters: {
    histogram: { component: PersonalizeSearchPricingHistogramDataProvider },
  },
  saveSearch: { component: PersonalizedSaveSearchDataProvider },
};
